__turbopack_context__.v({
  "bonus": "NumberSelectionBox-module__8dCBCW__bonus",
  "error": "NumberSelectionBox-module__8dCBCW__error",
  "inputContainer": "NumberSelectionBox-module__8dCBCW__inputContainer",
  "lineError": "NumberSelectionBox-module__8dCBCW__lineError",
  "minilottoNumberSelectionBox": "NumberSelectionBox-module__8dCBCW__minilottoNumberSelectionBox",
  "numberInput": "NumberSelectionBox-module__8dCBCW__numberInput",
  "numberSelectorContainer": "NumberSelectionBox-module__8dCBCW__numberSelectorContainer",
  "randomButton": "NumberSelectionBox-module__8dCBCW__randomButton",
  "randomIcon": "NumberSelectionBox-module__8dCBCW__randomIcon",
});
